module.exports = __webpack_public_path__ + "media/images/gimmicks/gimmick-square-d778ae2337fb8e3bfe405df755e9eb41.svg";